const themeOptions = {
  direction: "rtl",
  palette: {
    primary: {
      main: "#1bc47d",
      light: "#a5f3d2",
      dark: "#128756",
    },
    secondary: { main: "#593be2", light: "#c7bcf5", dark: "#2f179b" },
    red: { main: "#e2222e", light: "rgba(226,34,46,0.2)" },
    orange: { main: "#da5e22" },
    error: { main: "#e2222e", light: "rgba(226,34,46,0.2)" },
    chart: {
      0: { main: "#1bc47d", text: "#FFF" },
      1: { main: "#ffaf40", text: "#FFF" },
      2: { main: "#47cad8", text: "#FFF" },
      3: { main: "#ff7f50", text: "#FFF" },
      4: { main: "#c7bcf5", text: "#FFF" },
      5: { main: "#593be2", text: "#FFF" },
      6: { main: "#f44336", text: "#FFF" },
      7: { main: "#249ba8", text: "#FFF" },
      8: { main: "#a5f3d2", text: "#FFF" },
      9: { main: "#128756", text: "#FFF" },
    },
    grey: {
      1: "#1e1e1e",
      2: "#3e3f42",
      3: "#5d5f62",
      4: "#797979",
      5: "#d9d9d9",
      6: "#e6e6e6",
      7: "#f2f2f2",
      8: "#8c8d99",
      9: "#707070",
      10: "#efefef",
      11: "#4a4c58",
    },
    purple: {
      1: "#583be3",
      2: "#422bb1",
    },
  },
};

export default themeOptions;
